import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgFilterFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { d: "M11.83 7a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1-.117-1.993L5 5h1.17a3.001 3.001 0 0 1 5.66 0H19a1 1 0 0 1 .117 1.993L19 7h-7.17ZM17.83 11H19a1 1 0 0 1 .117 1.993L19 13h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1-.117-1.993L5 11h7.17a3.001 3.001 0 0 1 5.66 0ZM11.83 17H19a1 1 0 0 1 .117 1.993L19 19h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1-.117-1.993L5 17h1.17a3.001 3.001 0 0 1 5.66 0Z", fill: color }));
};
export default factorySvgIcon(SvgFilterFilled);
//# sourceMappingURL=SvgFilterFilled.js.map